import { render } from "./admin-class-list.vue?vue&type=template&id=94042cf6"
import script from "./admin-class-list.vue?vue&type=script&lang=js"
export * from "./admin-class-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__